import React from 'react';
import { connect } from 'react-redux';
import logo2 from "../../assets/image/stella/logo2.png";
import {HashLink} from "react-router-hash-link";

function Footer({ }) {
    return (
        <footer className="md:pt-10 pb-0">
            <div className="container">
                <div className="md:flex md:items-center md:justify-between">
                    <div className="p-8 md:w-[330px]">
                        <img alt="" loading="lazy" width="200" height="65" decoding="async"
                             data-nimg="1" className="max-md:mx-auto"
                             src={logo2}/>
                        <div className="mt-5 text-sm text-content/70">Somos <strong>Stella TV Oficial</strong>, el lugar
                            donde puedes adquirir una cuenta premium para disfrutar del mejor entretenimiento en línea.
                            ¡Ofrecemos los mejores planes y promociones!
                        </div>
                    </div>
                    <div className="p-8"><h4 className="text-lg font-semibold uppercase">Stella TV Global</h4>
                        <div className="mt-5 grid grid-cols-2 gap-2">
                            <ul className="grid gap-2 md:min-w-[157px]">
                                <li className="text-sm text-content/70 hover:text-content">
                                    <HashLink to='/#planes'>México</HashLink>
                                </li>
                                <li className="text-sm text-content/70 hover:text-content">
                                    <HashLink to='/#planes'>Ecuador</HashLink></li>
                                <li className="text-sm text-content/70 hover:text-content">
                                    <HashLink to='/#planes'>Colombia</HashLink></li>
                                <li className="text-sm text-content/70 hover:text-content">
                                    <HashLink to='/#planes'>Bolivia</HashLink></li>
                                <li className="text-sm text-content/70 hover:text-content">
                                    <HashLink to='/#planes'>Chile</HashLink>
                                </li>
                            </ul>
                            <ul className="grid gap-2 md:min-w-[157px]">
                                <li className="text-sm text-content/70 hover:text-content">
                                    <HashLink to='/#planes'>Perú</HashLink>
                                </li>
                                <li className="text-sm text-content/70 hover:text-content">
                                    <HashLink to='/#planes'>Estados
                                    Unidos</HashLink></li>
                                <li className="text-sm text-content/70 hover:text-content">
                                    <HashLink to='/#planes'>Paraguay</HashLink></li>
                                <li className="text-sm text-content/70 hover:text-content">
                                    <HashLink to='/#planes'>España</HashLink>
                                </li>
                                <li className="text-sm text-content/70 hover:text-content">
                                    <HashLink to='/#planes'>Otro</HashLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="grid grid-cols-2">
                        <div className="p-8"><h4 className="text-lg font-semibold uppercase">Ofrecemos</h4>
                            <div className="mt-5 flex gap-2">
                                <ul className="grid gap-2 md:min-w-[157px]">
                                    <li className="text-sm text-content/70 hover:text-content">Canales en vivo</li>
                                    <li className="text-sm text-content/70 hover:text-content">Películas HD</li>
                                    <li className="text-sm text-content/70 hover:text-content">Series de TV</li>
                                    <li className="text-sm text-content/70 hover:text-content">Canales de Adultos</li>
                                    <li className="text-sm text-content/70 hover:text-content">Deportes en vivo</li>
                                </ul>
                            </div>
                        </div>
                        <div className="p-8"><h4 className="text-lg font-semibold uppercase">Instalar en</h4>
                            <div className="mt-5 flex gap-2">
                                <ul className="grid gap-2 md:min-w-[157px]">
                                    <li className="text-sm text-content/70 hover:text-content">
                                        <HashLink to="/tv-box#inicio" className="flex items-center gap-2">
                                        TV Boxes</HashLink>
                                    </li>
                                    <li className="text-sm text-content/70 hover:text-content">
                                        <HashLink to="/smart-tv#inicio"
                                        className="flex items-center gap-2">
                                        Smart TV</HashLink></li>
                                    <li className="text-sm text-content/70 hover:text-content">
                                        <HashLink to="/fire-stick#inicio"
                                        className="flex items-center gap-2">
                                        Fire Stick</HashLink></li>
                                    <li className="text-sm text-content/70 hover:text-content">
                                        <HashLink to="/pc-mac#inicio"
                                        className="flex items-center gap-2">
                                        PC / MAC</HashLink></li>
                                    <li className="text-sm text-content/70 hover:text-content">
                                        <HashLink to="/descarga/#inicio"
                                        className="flex items-center gap-2">
                                        Celulares
                                        </HashLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="mt-5 pt-6 pb-5 border-t border-[#201F1F] flex md:justify-between items-center max-md:flex-col max-md:text-center gap-5 text-[13px] font-light text-content/70">
                    <ul className="flex items-center gap-10">
                        <li className="hover:text-content">Term of Use</li>
                        <li className="hover:text-content">Privacy Policy</li>
                        <li className="hover:text-content">Cookie Policy</li>
                    </ul>
                    <div>Copyright © 2025 Stella TV Streaming Media, All rights reserved. Present by Mix Centurion.
                    </div>
                </div>
            </div>
        </footer>
    )
}

const mapStateToProps = state => ({})

export default connect(mapStateToProps, {})(Footer)